var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOutlineGradient = function SvgStarOutlineGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9996 24.0998C16.0989 24.0998 16.1979 24.1218 16.2896 24.1662L22.9289 27.3745L22.0726 19.6948C22.0519 19.5088 22.1106 19.3222 22.2339 19.1812L27.2466 13.4668L20.0253 11.9475C19.8326 11.9068 19.6673 11.7832 19.5743 11.6092L15.9996 4.91516L12.4249 11.6092C12.3323 11.7832 12.1669 11.9068 11.9739 11.9475L4.75261 13.4668L9.76528 19.1812C9.88861 19.3222 9.94728 19.5088 9.92661 19.6948L9.07028 27.3745L15.7096 24.1662C15.8013 24.1218 15.9003 24.0998 15.9996 24.0998ZM23.7249 29.1665C23.6259 29.1665 23.5273 29.1448 23.4349 29.1002L15.9996 25.5072L8.56428 29.1002C8.34561 29.2055 8.08695 29.1845 7.88895 29.0442C7.69095 28.9038 7.58461 28.6672 7.61161 28.4262L8.56895 19.8395L2.99861 13.4888C2.84228 13.3108 2.79228 13.0632 2.86728 12.8385C2.94195 12.6138 3.13061 12.4455 3.36228 12.3968L11.3953 10.7068L15.4116 3.18616C15.5273 2.96883 15.7536 2.8335 15.9996 2.8335C16.2456 2.8335 16.4719 2.96883 16.5876 3.18583L20.6043 10.7068L28.6373 12.3968C28.8689 12.4455 29.0573 12.6138 29.1323 12.8385C29.2073 13.0632 29.1569 13.3108 29.0009 13.4888L23.4303 19.8395L24.3876 28.4262C24.4146 28.6672 24.3083 28.9038 24.1103 29.0442C23.9956 29.1252 23.8606 29.1665 23.7249 29.1665Z",
    fill: "url(#star_gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star_gradient",
    x1: 2.83301,
    y1: 2.8335,
    x2: 29.1661,
    y2: 29.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75F094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75B2F0"
  })))));
};
export default SvgStarOutlineGradient;